module.exports = __webpack_public_path__ + "static/media/chair-small.505c7b53.png";